module.exports = __webpack_public_path__ + "img/1.0fcf013c.jpeg";